import {
  GenericMachine,
  generateGenericDocs,
} from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { zipCodeApi as API } from '../Apis';

export const ZipCodeDocs: IDocs = generateGenericDocs(
  {
    title: 'ZipCode',
    description: '',
    version: '0.0.1',
    codeToExecute: '',
  },
  API.definitions,
);

const prepareCall = (stateRequestParameters: any) =>
  API.call.get({
    zipcode: stateRequestParameters?.zipcode,
  });

export const ZipCodeMachine = GenericMachine(prepareCall, {
  docs: ZipCodeDocs,
  definitions: API.definitions,
});
